import { css } from '@emotion/react';

export const achievementsDrawerBody = css`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 30px;

  height: 100%;
  text-align: center;
`;

export const content = css`
  display: flex;
  flex-direction: column;
  gap: 20px;

  max-width: 372px;
`;

export const achievementWithStars = css`
  position: relative;
`;

export const stars = css`
  position: absolute;

  left: -50%;
`;

export const achievementsDrawer = css`
  height: 100%;
  display: flex;
  flex-direction: column;
`;
